<template>
  <section>
    <v-dialog v-model="show" fullscreen>
      <v-card flat>
        <v-container style="padding:24px">
          <div class="dialog-toolbar">
            <v-col cols="9" md="11">
              <h3>Finalizar servicio</h3>
            </v-col>
            <v-col cols="1" md="1" class="pull-right">
              <v-icon @click="$emit('close-dialog')" style="transform: translateX(-15px)">close</v-icon>
            </v-col>
          </div>
          <div style="height: 50px;"></div>
          <v-row>
            <v-col cols="12" md="6" offset-md="3">
              <v-row>
                <v-col cols="4"><span>ID:</span></v-col>
                <v-col cols="8" style="display:flex;justify-content:flex-end;font-weight:bold;"><span>13456</span></v-col>
                <v-col cols="4"><span>Técnico:</span></v-col>
                <v-col cols="8" style="display:flex;justify-content:flex-end;font-weight:bold;"><span>Servicios Integrales Burone</span></v-col>
                <v-col cols="4"><span>Rubro:</span></v-col>
                <v-col cols="8" style="display:flex;justify-content:flex-end;font-weight:bold;"><span>Vidrieros</span></v-col>
                <v-col cols="4"><span>Servicio:</span></v-col>
                <v-col cols="8" style="display:flex;justify-content:flex-end;font-weight:bold;"><span>Colocación de vidrio</span></v-col>
                <v-col cols="4"><span>Total:</span></v-col>
                <v-col cols="8" style="display:flex;justify-content:flex-end;font-weight:bold;"><span>$8.000</span></v-col>
                <v-col cols="12" style="display:flex; justify-content: center; align-items: center;">
                  <VueSignaturePad
                    v-if="showPad"
                    class="hidden-md-and-up"
                    id="signature"
                    width="90vw"
                    height="90vw"
                    ref="signaturePad"
                    :options="options"
                  />
                  <!-- <VueSignaturePad
                    v-if="showPad"
                    class="hidden-sm-and-down"
                    id="signature"
                    width="300px"
                    height="300px"
                    ref="signaturePad"
                    :options="options"
                  /> -->
                </v-col>
                <v-col cols="12" style="padding-bottom:0">
                  <v-text-field
                    label="Nombre"
                    v-model="name"
                  />
                </v-col>
                <v-col cols="12" style="padding-top:0">
                  <v-text-field
                    label="DNI"
                    v-model="dni"
                    type="number"
                  />
                </v-col>
                <v-col cols="6">
                  <v-btn color="rapired" dark @click="undo">LIMPIAR</v-btn>
                </v-col>
                <v-col cols="6" style="display:flex; justify-content: flex-end;">
                  <v-btn color="secondary" @click="save">CONFIRMAR</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>

export default {
  name: 'finalize-service',
  props: {
    show: Boolean,
    visitId: Number
  },
  data () {
    return {
      showPad: false,
      name: null,
      dni: null,
      options: {
        penColor: '#000'
      }
    }
  },
  mounted () {
    this.showPadTimeout()
  },
  methods: {
    showPadTimeout () {
      setTimeout(() => {
        this.showPad = true
      }, 10)
    },
    undo () {
      this.$refs.signaturePad.clearSignature()
      this.name = null
      this.dni = null
    },
    save () {
      const { data } = this.$refs.signaturePad.saveSignature()
      if (this.name && this.dni) {
        const body = { id: 9, signature: data, signature_name: this.name, signature_dni: this.dni }
        this.axios.post(`/visit/${this.visitId}/status/`, body).then(response => {
          this.$emit('reload-request')
          this.$emit('close-dialog')
        })
      }
    }
  }
}
</script>
<style scoped>
@media(max-width:959px){
}
@media(min-width:960px){
  .pull-right {
    display: flex;
    justify-content: flex-end;
  }
}
#signature {
  border: 1px solid black;
}
</style>
